module.exports = "http://cdn.realive.com.ua/src/views/player/help/images/pd2.jpg";